function escapeCsvCell(value) {
  const text = value == null ? '' : String(value);
  if (/[",\r\n]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
}

function escapeXmlCell(value) {
  const text = value == null ? '' : String(value);
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function triggerDownload(filename, blob) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export function downloadCsv(filename, headers, rows) {
  const lines = [
    headers.map(escapeCsvCell).join(','),
    ...rows.map((row) => row.map(escapeCsvCell).join(',')),
  ];
  const blob = new Blob(['\uFEFF' + lines.join('\r\n')], {
    type: 'text/csv;charset=utf-8;',
  });
  triggerDownload(filename, blob);
}

/** Excel-compatible SpreadsheetML (.xls) — opens natively in Excel / LibreOffice. */
export function downloadExcel(filename, headers, rows) {
  const headerCells = headers
    .map((h) => `<Cell><Data ss:Type="String">${escapeXmlCell(h)}</Data></Cell>`)
    .join('');

  const dataRows = rows
    .map((row) => {
      const cells = row
        .map((cell) => {
          const text = cell == null ? '' : String(cell);
          const isNumber = text !== '' && /^-?\d+(\.\d+)?$/.test(text);
          const type = isNumber ? 'Number' : 'String';
          return `<Cell><Data ss:Type="${type}">${escapeXmlCell(text)}</Data></Cell>`;
        })
        .join('');
      return `<Row>${cells}</Row>`;
    })
    .join('');

  const xml = `<?xml version="1.0"?>
<?mso-application progid="Excel.Sheet"?>
<Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet"
 xmlns:o="urn:schemas-microsoft-com:office:office"
 xmlns:x="urn:schemas-microsoft-com:office:excel"
 xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet">
 <Worksheet ss:Name="Report">
  <Table>
   <Row>${headerCells}</Row>
   ${dataRows}
  </Table>
 </Worksheet>
</Workbook>`;

  const blob = new Blob([xml], {
    type: 'application/vnd.ms-excel;charset=utf-8;',
  });
  const name = filename.toLowerCase().endsWith('.xls') || filename.toLowerCase().endsWith('.xlsx')
    ? filename.replace(/\.xlsx$/i, '.xls')
    : `${filename}.xls`;
  triggerDownload(name, blob);
}

export function stampFileDate(date = new Date()) {
  return date.toISOString().slice(0, 10);
}
